exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".unfair[data-v-eab318be] {\n  font-size: 13px;\n  line-height: 18px;\n}\n.unfair__msg[data-v-eab318be] {\n    color: #e74c3c;\n}\n", ""]);

// exports
